module.exports = __webpack_public_path__ + "static/media/searching.115b013c.svg";